import axios from '@/axios'
import { getDeviceId } from '@/utils/device'


export default {
    namespaced: true,
    state: {
        token: null,
        user: null,
        partialToken: null,
        deviceStatus: null,  // "new" | "known"
    },
    getters: {
        authenticated(state) {
            return state.token
        },
        user(state) {
            return state.user
        },
        superuser(state) {
            return state.user ? state.user.is_superuser : false
        },
        staff(state) {
            return state.user ? state.user.is_staff : false
        },
        permissions(state) {
            return state.user ? state.user.permissions : []
        },
        requires2fa(state) {
            return !!state.partialToken
        },
        deviceStatus(state) {
            return state.deviceStatus
        },
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_USER(state, user) {
            state.user = user
        },
        SET_PARTIAL_AUTH(state, { partialToken, deviceStatus }) {
            state.partialToken = partialToken
            state.deviceStatus = deviceStatus
        },
        CLEAR_PARTIAL_AUTH(state) {
            state.partialToken = null
            state.deviceStatus = null
        },
    },
    actions: {
        async signIn({ commit }, credentials) {
            delete axios.defaults.headers.common['Authorization']
            const response = await axios.post('api/auth/jwt/create/', {
                ...credentials,
                device_id: getDeviceId(),
            })
            commit('SET_PARTIAL_AUTH', {
                partialToken: response.data.partial_token,
                deviceStatus: response.data.device_status,
            })
        },

        async verify2fa({ dispatch, state }, { pin }) {
            const response = await axios.post('api/auth/2fa/verify/', {
                partial_token: state.partialToken,
                device_id: getDeviceId(),
                pin,
            })
            return dispatch('attempt', response.data.access)
        },

        async initiateDeviceSetup({ state }) {
            const response = await axios.post('api/auth/2fa/setup/initiate/', {
                partial_token: state.partialToken,
                device_id: getDeviceId(),
            })
            return response.data  // { email_hint }
        },

        async setup2fa({ dispatch, state }, { pin, deviceName, emailCode }) {
            const response = await axios.post('api/auth/2fa/setup/', {
                partial_token: state.partialToken,
                device_id: getDeviceId(),
                pin,
                device_name: deviceName,
                email_code: emailCode,
            })
            return dispatch('attempt', response.data.access)
        },

        async attempt({ dispatch, commit, state }, token) {
            if (token) {
                commit('SET_TOKEN', token)
                let response = await axios.get('api/auth/users/me/')
                commit('SET_USER', response.data)
                await dispatch('project/set_constants', null, { root: true })
                await dispatch('uiPreferences/fetchAll', null, { root: true })
                dispatch('project/delete_error', null, { root: true })
            }
            if (!state.token) {
                return
            }
        },

        cancelAuth({ commit }) {
            commit('CLEAR_PARTIAL_AUTH')
        },

        signOut({ commit, dispatch }) {
            commit('SET_USER', null)
            commit('SET_TOKEN', null)
            commit('CLEAR_PARTIAL_AUTH')
            commit('project/set_project', null, { root: true })
            dispatch('uiPreferences/clear', null, { root: true })
        },
    },
}
